module.exports = __webpack_public_path__ + "static/media/help-banner-default.2155984b.png";